import { Resume } from '@sr/types';
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CheckIcon,
  EditIcon,
  Input,
  NModal,
  Text,
} from '../../ui';
import API from '../../utils/api';

const ChangeSlug = ({ resume }: { resume: Resume }) => (
  <NModal OpenButton={<OpenButton />} title="Change Resume URL">
    <ModalContents resume={resume} />
  </NModal>
);

function ModalContents({
  closeModal,
  resume,
}: {
  closeModal?: () => void;
  resume: Resume;
}) {
  const [slug, setSlug] = useState(resume.slug);
  const [error, setError] = useState('');

  useEffect(() => {
    if (slug === resume.slug) {
      // Do nothing
    } else if (slug.length < 3) {
      // Assure the slug is at least 3 characters long
      setError('Addresses must be at least 3 characters long.');
    } else if (!/^[0-9a-zA-Z-_]+$/.test(slug)) {
      setError('Addresses can only contain letters, numbers and hyphens.');
    } else {
      API.slug.isAvailable({ slug }).then((isAvailable) => {
        if (!isAvailable) {
          setError('The address is unavailable');
        } else {
          setError('');
        }
      });
    }
  }, [resume.slug, slug]);

  function saveSlug() {
    API.resume
      .updateSlug({ resume, slug })
      .then(closeModal)
      .catch((error) =>
        setError('There was an error updating the address. Please try again.')
      );

    API.events.logEvent({
      userId: resume.owner,
      eventName: 'Resume Slug Changed',
    });
  }

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!error && slug !== resume.slug) {
      saveSlug();
    }
  }

  return (
    <Box id="gi-share-slug-form">
      <Text variant="base" mb={2}>{`https://rsm.io/${slug}`}</Text>
      <Text variant="caption" mb={5} color="black50">
        Visitors are not redirected from the old URL.
      </Text>
      <form onSubmit={handleSubmit}>
        <Input
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          mb={5}
          autoFocus
        />
        {error && <Text mb={5}>{error}</Text>}
        <Button
          sx={{ justifyContent: 'space-between' }}
          data-testid="save-slug"
          disabled={!!error || slug === resume.slug}
        >
          Save <CheckIcon size={24} color="white" />
        </Button>
      </form>
    </Box>
  );
}

function OpenButton({ onClick }: { onClick?: () => void }) {
  function handleClick() {
    onClick && onClick();
  }

  return (
    <Button
      onClick={handleClick}
      variant="link"
      ml={-4}
      py={2}
      id="gi-share-open-change-slug"
      data-testid="open-change-slug"
    >
      <EditIcon size={24} mr={2} />
      <Text color="black" pl={2}>
        Edit resume link
      </Text>
    </Button>
  );
}

export default ChangeSlug;
